import { api } from '@/api/api';
import { ContactTransformInstance } from './contact_transform';
export class ContactCollegeHelper {
    constructor() {
        this.eventApi = api.getEventApi();
        this.contactTrans = ContactTransformInstance;
        this.dbApi = api.getNewDBApi();
        this.customerDBName = 'contact_customer';
        this.colleagueSyncTimes = 0;
        this.tableNames = {
            contact: 'contact',
            org: 'org',
            orgContact: 'orgContact',
            orgManager: 'orgManager',
            label: 'label',
            colleagueContact: 'colleagueContact',
        };
    }
    getColleagueSyncTimes() {
        return this.colleagueSyncTimes;
    }
    sendEdmColleagueNotify() {
        const syncTimes = this.getColleagueSyncTimes() + 1;
        this.colleagueSyncTimes = syncTimes;
        const contactNotifyData = {
            eventName: 'colleagueEdmNotify',
            eventStrData: 'notify',
            eventData: {
                syncTimes,
            },
            eventSeq: 0,
            noLog: true,
        };
        this.eventApi.sendSysEvent(contactNotifyData);
    }
    async getColleagueContactIdList() {
        const list = await this.dbApi.getByRangeCondition({
            dbName: this.customerDBName,
            tableName: this.tableNames.colleagueContact,
        });
        const idSet = new Set();
        list.forEach(item => {
            idSet.add(item.contactId);
        });
        return [...idSet];
    }
    async handleColleagueList(list, needDeleteLastData = true) {
        try {
            const _lastUpdateTime = Date.now();
            let insertData = [];
            list.forEach(item => {
                insertData = insertData.concat(this.contactTrans.transColleagueToUnitContact(item, _lastUpdateTime));
            });
            await this.dbApi.putAll({
                tableName: this.tableNames.colleagueContact,
                dbName: this.customerDBName,
            }, insertData);
            if (needDeleteLastData) {
                await this.dbApi.deleteByByRangeCondition({
                    dbName: this.customerDBName,
                    tableName: this.tableNames.colleagueContact,
                    adCondition: {
                        field: '_lastUpdateTime',
                        args: [0, _lastUpdateTime - 10, true, true],
                        type: 'between',
                    },
                });
            }
            this.sendEdmColleagueNotify();
            return insertData;
        }
        catch (e) {
            console.error('[contact_college] handleColleagueList error', e);
            return [];
        }
    }
    async getContactIdByUnitId(params) {
        const { idList } = params;
        const res = await this.dbApi.getByRangeCondition({
            dbName: this.customerDBName,
            tableName: this.tableNames.colleagueContact,
            adCondition: {
                args: [idList],
                field: 'orgId',
                type: 'anyOf',
            },
        });
        const ret = {};
        res.forEach(item => {
            const contactIdList = ret[item.orgId] || [];
            if (item.contactId) {
                contactIdList.push(item.contactId);
            }
            ret[item.orgId] = contactIdList;
        });
        return ret;
    }
    initDB() {
        this.dbApi.initDb(this.customerDBName);
    }
}
export const ContactCollegeHelperInstance = new ContactCollegeHelper();
